import type { DeepPartial, Theme } from '@chakra-ui/react';

export const fonts: DeepPartial<Theme['fonts']> = {};
